module.exports = __webpack_public_path__ + "static/media/facebook-icon.9ddcc1b1.svg";